<?xml version="1.0" encoding="UTF-8"?>
<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>01 Atoms / Icons  / Bubble</title>
    <g id="01-Atoms-/-Icons--/-Bubble" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <circle id="Oval" stroke="#131313" cx="7" cy="7" r="6.5"></circle>
    </g>
</svg>